import * as $ from "jquery";


var savedSearchQueriesLocalStorageName = "savedSearchQueries";
$(function () {
    var currentSearchQuery = CreateSearchQueryObject();  //currentSearchQuery in form of a JSON object
    var savedSearchQueries = "";
    //Get savedSearchQueries from localstorage
    if (localStorage.getItem(savedSearchQueriesLocalStorageName)) {
        savedSearchQueries = JSON.parse(localStorage.getItem(savedSearchQueriesLocalStorageName)); //savedSearchQueries in form of a JSON object
    }
    //List saved search queries if we are at the SavedSearchsPage
    var body = $("body");
    if (body.data("pagetype") == "HittaSavedSearchesPage") {
        ListSavedSearches(savedSearchQueries);
    }
    $(".remove").click(function () {
        RemoveSavedSearchQueryAndListItem(this.parentNode, $(this.parentNode).children('.hidden')[0].innerHTML);
    });
    //If at SearchPage, flag if current search query is saved, if not, set listener
    if (body.data("pagetype") == "HittaSearchPage") { //postifx (1) autogenerated bcs SearchPage pagetype allreday exist at Area/SU
        CheckIfCurrentSearchQueryIsSaved(currentSearchQuery, savedSearchQueries);
        $("#save-search").click(function () {
            AddSearchQueryToLocalStorage(currentSearchQuery, savedSearchQueries);
        });
    }
});

//Creats a JSON object of the currentSearchQuery
function CreateSearchQueryObject() {
    //TODO for all controlls check values for null and give empty string if so.
    var searchQueryValue = $("#search").val();
    if (searchQueryValue == null) searchQueryValue = "";
    var searchQueryText = searchQueryValue;
    var searchQueryName = $("#search").attr("name");
    if (searchQueryName == null) searchQueryName = "";

    var select1Val = $("#select-1 :selected").val();
    if (select1Val == null) select1Val = "";
    var select1Text = $("#select-1 :selected").text();
    if (select1Text == null) select1Text = "";
    var select1Name = $("#select-1").attr("name");
    if (select1Name == null) select1Name = "";

    var select2Val = $("#select-2 :selected").val();
    if (select2Val == null) select2Val = "";
    var select2Text = $("#select-2 :selected").text();
    if (select2Text == null) select2Text = "";
    var select2Name = $("#select-2").attr("name");
    if (select2Name == null) select2Name = "";

    var select3Val = $("#select-3 :selected").val();
    if (select3Val == null) select3Val = "";
    var select3Text = $("#select-3 :selected").text();
    if (select3Text == null) select3Text = "";
    var select3Name = $("#select-3").attr("name");
    if (select3Name == null) select3Name = "";

    var sortVal = $("#ul-sort").find("[data-active]").data("value");
    if (sortVal == null) sortVal = "";
    var sortText = $("#ul-sort").find("[data-active]").text();
    if (sortText == null) sortText = "";
    var sortName = "o";

    var groupVal = $("#ul-group").find("[data-active]").data("value");
    if (groupVal == null) groupVal = "";
    var groupText = $("#ul-group").find("[data-active]").text();
    if (groupText == null) groupText = "";
    var groupName = "group";

    var d = new Date();
    var day = d.getDate();
    var month = d.getMonth() + 1;
    var year = d.getFullYear();
    var date = year + "-" + month + "-" + day;

    var searchQueryObject = [
        { "name": searchQueryName, "text": searchQueryText, "value": searchQueryValue },
        { "name": select1Name, "text": select1Text, "value": select1Val },
        { "name": select2Name, "text": select2Text, "value": select2Val },
        { "name": select3Name, "text": select3Text, "value": select3Val },
        { "name": sortName, "text": sortText, "value": sortVal },
        { "name": "date", "text": date, "value": date },
        { "name": groupName, "text": groupText, "value": groupVal }];
    return searchQueryObject;
}
//List saved search queries
function ListSavedSearches(savedSearchQueries) {
    if (savedSearchQueries == "") {
        $("#no-saved-searches-info").removeClass("hidden");
        return;
    };
    savedSearchQueries.sort(compare);// <(^^)>
    savedSearchQueries.forEach((searchQuery) => {
        if (searchQuery == "") return;
        var dateSaved = searchQuery[5]["value"];
        var splitedDate = dateSaved.split("-");
        var language = $("html").attr('lang');
        //$.datepicker.setDefaults($.datepicker.regional[language]);
        $.datepicker.setDefaults(
            $.extend(
                $.datepicker.regional[language]
            )
        );

        var dateTextRepresentation = $.datepicker.formatDate("dd MM yy", new Date(splitedDate[0], splitedDate[1] - 1, splitedDate[2]));
        $(".saved-searches ul").append('<li>' +
            '<a href="javascript:void(0)" onclick=\'SubmitSearchQuery(' + JSON.stringify(searchQuery) + ');\'>' +
            searchQuery[0]["text"] +
            '</a> ' +
            "<p>" + (searchQuery[1]["value"] == "" ? "" : searchQuery[1]["text"] + ", ") +
            (searchQuery[2]["value"] == "" ? "" : searchQuery[2]["text"] + ", ") +
            (searchQuery[3]["value"] == "" ? "" : searchQuery[3]["text"] + ", ") +
            (searchQuery[4]["value"] == "" ? "" : searchQuery[4]["text"] + ", ") +
            (searchQuery[6]["value"] == "" ? "" : searchQuery[6]["text"] + " ") + "</p>" + //number 5 is date and displayed below

            '<span class="hidden">' + JSON.stringify(searchQuery) + '</span>' +

            '<a href="javascript:void(0)" class="icon remove">' +
            '<span class="">' +
            'Ta bort sparad sökning' +
            '</span>' +
            '</a>' +
            '<p>' +
            'Sparad: ' +
            '<time datetime="' + dateSaved + '">' +
            dateTextRepresentation +
            '</time>' +
            '</p>' +
            '</li>');
    });
}
function compare(a, b) {
    if (a[0]["text"] < b[0]["text"])
        return -1;
    if (a[0]["text"] > b[0]["text"])
        return 1;
    return 0;
}
//Sets search query and submit search form.
function SubmitSearchQuery(searchQuery) {
    if (searchQuery == "") return;
    var url = searchQuery[6]["value"] + "?" +
        searchQuery[0]["name"] + "=" + searchQuery[0]["value"] + "&" +
        searchQuery[1]["name"] + "=" + searchQuery[1]["value"] + "&" +
        searchQuery[2]["name"] + "=" + searchQuery[2]["value"] + "&" +
        searchQuery[3]["name"] + "=" + searchQuery[3]["value"] + "&" +
        searchQuery[4]["name"] + "=" + searchQuery[4]["value"] + "&" +
        searchQuery[5]["name"] + "=" + searchQuery[5]["value"];
    window.location.href = url;
}
//Saves the provided search query to localstorage
function AddSearchQueryToLocalStorage(currentSearchQuery, savedSearchQueries) {
    if (currentSearchQuery == "") return;
    if (savedSearchQueries == "") {
        savedSearchQueries =
            [
                currentSearchQuery
            ];
    } else {
        savedSearchQueries.push(currentSearchQuery);
    }
    var stringifiedSearchQueries = JSON.stringify(savedSearchQueries);
    //save searchqueries to localstorage
    localStorage.setItem(savedSearchQueriesLocalStorageName, stringifiedSearchQueries);
    MarkSearchQuerySaved();
}
//Checks if the current search query is saved
function CheckIfCurrentSearchQueryIsSaved(currentSearchQuery, savedSearchQueries) {
    if (currentSearchQuery == "" || savedSearchQueries == "") return;
    savedSearchQueries.forEach(function (searchQuery) {
        if (searchQuery[0]["value"] != currentSearchQuery[0]["value"]) return;
        else if (searchQuery[1]["value"] != currentSearchQuery[1]["value"]) return;
        else if (searchQuery[2]["value"] != currentSearchQuery[2]["value"]) return;
        else if (searchQuery[3]["value"] != currentSearchQuery[3]["value"]) return;
        else if (searchQuery[4]["value"] != currentSearchQuery[4]["value"]) return;
        else if (searchQuery[6]["value"] != currentSearchQuery[6]["value"]) return; //Number 5 is date and is not included in check
        MarkSearchQuerySaved();
    });
}
//Marks current search query as saved
function MarkSearchQuerySaved() {
    $("#search-saved").removeClass("hidden");
    $("#save-search").addClass("hidden");
}
//Remove saved search query and the <li> from the <ul>
function RemoveSavedSearchQueryAndListItem(savedSearchQueryListItem, savedSearchQueryToRemove) {
    if (savedSearchQueryToRemove == "" || localStorage.getItem(savedSearchQueriesLocalStorageName) == null) return;
    var savedSearchQueries = JSON.parse(localStorage.getItem(savedSearchQueriesLocalStorageName));

    var newSearchQueries = [];
    savedSearchQueries.forEach(function (searchQuery) {
        if (searchQuery[0]["value"] == savedSearchQueryToRemove[0]["value"] &&
            searchQuery[1]["value"] == savedSearchQueryToRemove[1]["value"] &&
            searchQuery[2]["value"] == savedSearchQueryToRemove[2]["value"] &&
            searchQuery[3]["value"] == savedSearchQueryToRemove[3]["value"] &&
            searchQuery[4]["value"] == savedSearchQueryToRemove[4]["value"] &&
            searchQuery[6]["value"] == savedSearchQueryToRemove[6]["value"]) { //Number 5 is date and is not included in check
            return;
        } else { newSearchQueries.push(searchQuery); }
    });
    OwerwriteSavedSearchQueries(JSON.stringify(newSearchQueries));
    $(savedSearchQueryListItem).remove();
}
//Overwrite savedSearchQueries in localstorage
function OwerwriteSavedSearchQueries(newSavedSearchQueries) {
    localStorage.setItem(savedSearchQueriesLocalStorageName, newSavedSearchQueries);
}